var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../assets/header.png"),"alt":""}})]),_c('div',{staticClass:"logo1"},[_vm._v("国家市场监督管理总局专业技术人才开发中心"),_c('br'),_vm._v("在线报名及发证管理系统")])])
}]

export { render, staticRenderFns }